import React from "react";
import { CatalogItemDescription } from "../CatalogItemDescription/CatalogItemDescription";
import ICatalog_Item from "../../../models/ICatalog_Item";
import IPrice_Group from "../../../models/IPrice_Group";
import { OwIconButton } from "../OwIconButton/OwIconButton";
import "./DescriptionExpander.scss";
import OwLabel from "../OwLabel/OwLabel";
import IOrder_Item from "../../../models/IOrder_Item";

type Props = {
    catalogItem: ICatalog_Item;
    priceGroup?: IPrice_Group;
    orderItem?: IOrder_Item;
    height?: string;
};

export const DescriptionExpander = (props: Props) => {
    const isLongDescription = (props.catalogItem.description?.length || 0) > 50;
    const [isExpanded, setIsExpanded] = React.useState(false);
    const contentClass = `${isExpanded ? "open" : ""} ${isLongDescription && !isExpanded ? "blur" : ""} ${
        isLongDescription ? "content" : ""
    }`;

    const style = props.height && !isExpanded ? { height: props.height } : {};

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className={"DescriptionExpander expandingDivContainer"}>
            <div className={contentClass} style={style}>
                <CatalogItemDescription catalogItem={props.catalogItem} priceGroup={props.priceGroup} orderItem={props.orderItem} />
            </div>
            {isLongDescription ? (
                <div className={"text-center"}>
                    {isExpanded ? (
                        <div className={"pointer border-top"} onClick={toggleExpanded}>
                            <OwIconButton iconClass={"fas fa-chevron-down"} iconColorClass={""} fn={toggleExpanded} />
                            <OwLabel className={"ms-2 text-small text-muted pointer"} title={"view_less"} />
                        </div>
                    ) : (
                        <div className={"pointer border-top"} onClick={toggleExpanded}>
                            <OwIconButton iconClass={"fas fa-chevron-up"} iconColorClass={""} fn={toggleExpanded} />
                            <OwLabel className={"ms-2 text-small text-muted pointer"} title={"view_more"} />
                        </div>
                    )}
                </div>
            ) : null}
        </div>
    );
};
